import { render, staticRenderFns } from "./ShowPicture.vue?vue&type=template&id=12f09daa&scoped=true&"
import script from "./ShowPicture.vue?vue&type=script&lang=js&"
export * from "./ShowPicture.vue?vue&type=script&lang=js&"
import style0 from "./ShowPicture.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ShowPicture.vue?vue&type=style&index=1&id=12f09daa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f09daa",
  null
  
)

export default component.exports